import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';

// Import existing types to use in function signatures
import { Project } from '../../models/Project';

/**
 * Hook for getting a project by ID with built-in state management
 * Includes Zod validation for type safety
 */
export const useGetProject = () => {
  const { callAPI, ...state } = useAPI<Project>(); // GET

  /**
   * Get a project by ID
   * @param projectId - The project ID
   * @returns Promise with the fetched project when available
   */
  const action = async (projectId: string): Promise<Project | null> => {
    try {
      const response = await callAPI(buildApiUrl(`project/${projectId}`));

      // Validate the response data
      const validatedData = /* ProjectSchema.parse( */ response /* ) */ as Project;

      return validatedData;
    } catch (error) {
      console.error('Error in useGetProject:', error);
      return null;
    }
  };

  return {
    action,
    ...state,
  };
};
